import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'dummyCard',
  props: {
  customClass: {
    type: String,
    required: false,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
  titleClass: {
    type: String,
    default: "",
  },
  titleButton: {
    type: String,
    default: "",
  },
  isShowButton: {
    type: Boolean,
    default: true,
  },
},
  emits: ["button:click"],
  setup(__props, { emit }) {

const props = __props;





const handleActionButton = () => {
  emit("button:click");
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`dummy tw-absolute tw-top-[66px] tw-bottom-0 tw-left-0 tw-right-0 tw-z-[1] tw-items-center tw-justify-center tw-flex tw-flex-col tw-gap-[25px] ${__props.customClass}`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`tw-text-[#211F58] tw-font-[Poppins] tw-text-[16px] tw-leading-[135%] tw-text-center title ${__props.titleClass}`)
    }, _toDisplayString(__props.title), 3),
    (__props.isShowButton)
      ? (_openBlock(), _createBlock(_component_b_button, {
          key: 0,
          variant: "primary",
          class: "button-verify tw-bg-[#387DFF] tw-ml-[10px] tw-items-center tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[100px] tw-h-[36px]",
          type: "submit",
          onClick: handleActionButton
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.titleButton), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})